import React from "react";

const PrivacyPolicyPage: React.FC = () => (
  <div className="max-w-2xl mx-auto p-8 bg-white rounded-lg mt-12">
    <h1 className="text-2xl font-bold mb-4">Privacy Policy</h1>
    <p className="mb-2">This is the placeholder for the Privacy Policy. Please update this page with your actual privacy practices and legal requirements.</p>
    <p className="mb-2">Your privacy is important to us. This page will describe how we collect, use, and protect your information.</p>
    <p>If you have any questions, please contact us at [Insert contact email].</p>
  </div>
);

export default PrivacyPolicyPage; 